import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";

/**
 * @description 江苏文交所二期
 * @return {/culturalExchange_maotaisecond/exchangeRecord}
 */

const ExchangeRecord = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([])
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);

  useEffect(() => {
    (()=>{
      getData(true);
      // var m = [{},{}];
      // setRecords(m);
    })()

  }, []);

  const getData = async (loading = false, isRefresh = true) => {
    try {
      if (loading) showLoading();
      
      if (isRefresh) {
        currentPage.current = 1;
      } else {
        currentPage.current = currentPage.current + 1;
      }
      
      const res = await Service.getRecoveryRecord(currentPage.current);
      if (loading) hideLoading();
      if(res?.data?.record?.length > 0){
        const newList = res.data.record || [];
        if (currentPage.current === 1) {
          setRecords(newList);
        } else {
          setRecords([...records, ...newList]);
        }
        console.log('newList===>', newList)
        setIsLoad(true);
        setHasMore(newList.length >= pageSize.current);
      } else {
        setIsLoad(true);
        setHasMore(false);
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const loadMore = async () => {
    await getData(false, false);
  }

  const onRefresh = async () => {
    await getData(false, true);
  }

  const RecordItem = (item, index) => {
    return (
      <div 
        key={item.id} 
        className={Styles.recordCard}
      >
        <div className={Styles.cardLeft}>
          <div className={Styles.thumb}>
            <img src={item.upgradeImg || ''} alt={item.afterName} />
          </div>
          <div className={Styles.countTag}>
            <div className={Styles.countTagTitle}>{item.afterName || ''}</div>
            <div className={Styles.countTagValue}>x{item.upgradeAfterNum || 0}</div>
          </div>
        </div>
        <div className={Styles.line}></div>
        <div className={Styles.cardRight}>
          <div className={Styles.infoRow}>
            <span className={Styles.label}>兑换使用材料</span>
            <span className={Styles.valueRight}>{item.remarka || ''}</span>
          </div>
          <div className={Styles.infoRow}>
            <span className={Styles.label}>材料数量</span>
            <span className={Styles.valueRight}>{item.upgradeBeforeNum || 0}</span>
          </div>
          <div className={Styles.infoRow}>
            <span className={Styles.label}>兑换时间</span>
            <span className={Styles.valueRight}>{item.recoveryTime || ''}</span>
          </div>
        </div>
      </div>
    )
  }

  const handleBack = () => {
    // if (window.JsBridge.hasWebViewBridge()) {
    //     window.JsBridge.back();
    //   } else {
    //     navigate(-1);
    //   };
      navigate(-1);
  }
  
  return (
    <div className={Styles.collectionRecord}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}>
      </div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}>
        </div>
        <div className={Styles.title}>领取记录</div>
        <div className={Styles.placeholder}></div>
      </div>

      {/* 内容区域 */}
      <div className={Styles.content}>
        <ListView
          dataSource={records}
          hasMore={hasMore}
          renderItem={RecordItem}
          onRefresh={onRefresh}
          onEndReached={loadMore}
          isLoad={isLoad}
          emtyDesc="暂无领取记录"
        />
      </div>
    </div>
  )
}

export default ExchangeRecord
